import Vue from 'vue';
import Component from 'vue-class-component';
import { censorDataIfNeeded } from "@/utils/sensitiveNumbersUtils";

@Component
export default class SensitiveNumbersMixin extends Vue {

  /**
   * 🔒 Function which hides a certain number and substitutes it with asterisks
   */
  public censorableData(value: any, limitToUrl?: string): string {
    return censorDataIfNeeded(value, limitToUrl)
  }
}